import React, { useState,  useContext, } from 'react'
import { Link, useNavigate, } from 'react-router-dom';
import { Typography, Row, Space, Button, Drawer, } from 'antd';
import { WifiOutlined, DeleteOutlined, SlidersOutlined, UserOutlined, } from '@ant-design/icons';
import { NocContext } from '../../../../context/noc-context';
import { EditCustomerInformationForm } from './EditCustomerInformationForm.component';
import { NocDeleteCustomerModal } from '../../Modals/NocDeleteCustomerModal';
import { Restricted } from '../../../UI/Restricted.component';
import './NocListItem.css';

const { Text } = Typography;
const size = 'default';

export const NocListItem = ({ dataSource: nocItem, setDataSource, refreshHandler, ...props }) => {

    const { id, companyName, alertStatus, Places, } = nocItem;

    const navigate = useNavigate();
    
    const [nocState, nocDispatch ] = useContext(NocContext);
    const [deleteCustomerModal, setDeleteCustomerModal] = useState(false);
    const [displayCustomerInformation, setDisplayCustomerInformation] = useState(false);

    const status = (alertStatus) => {
        return alertStatus ? 'success' : 'error'
    } 

    const onClickHandler = () => {
        nocDispatch({
            type: 'SET_CURRENT_NOC_ITEM', 
            payload: nocItem,
        })

        navigate(
            {
                pathname: '/app/station',
                search: `${id}`,
            }
            , 
            { state: { currentNocItem: nocItem } }
        );
    }

    return(
        <>
            <div id={`noc__list__item-${id}`} {...props} className={`${props.className || ''}noc__list__item`} onClick={() => onClickHandler()}>
                <div className='noc__list__item__section noc__list__item__alert-status'>
                    <WifiOutlined style={{color: `var(--${status(Places ? Places.some( (place) => place.status === true ) : false)}-color)`}}/>
                </div>
                <div className='noc__list__item__section noc__list__item__information'>
                    <Text strong>{companyName}</Text>
                    <Row>
                        <Space size="middle">
                            <Text><span className="noc__list__item__information--label">Total Sites:</span> {Places ? Places.length : 'N/A'}</Text>
                            <Text><span className="noc__list__item__information--label">Sites Active:</span> {Places ? Places.filter( (place) => place.status === true ).length : 'N/A'}</Text>
                            <Text><span className="noc__list__item__information--label">Sites Inactive:</span> {Places ? (Places.filter( (place) => place.status === false ).length + Places.filter( (place) => place.status === null ).length ) : 'N/A'}</Text>
                        </Space>
                    </Row>
                </div>
                <div className='noc__list__item__section'>
                    <Space>
                        <Button
                            icon={<UserOutlined/>} 
                            size={size} 
                            color='default' 
                            variant='solid' 
                            onClick={(e) => {
                                e.stopPropagation(); 
                                setDisplayCustomerInformation(true)
                            }}
                            >
                            Customer Information
                        </Button>
                        <Link 
                            to={{
                                    pathname: '/app/station', 
                                    search: `${id}`,
                                }}
                            state={{
                                    currentNocItem: nocItem,
                                    advancedSearch: false
                                }}
                            >
                            <Button size={size} icon={<SlidersOutlined/>} onClick={() => onClickHandler()}>View Stations</Button>
                        </Link>
                        <Restricted to='noc.deleteCustomer'>
                            <Button onClick={(e) => {e.stopPropagation(); setDeleteCustomerModal(true)}} size={size} danger type="primary" icon={<DeleteOutlined/>}></Button>
                        </Restricted>
                    </Space>
                </div>
            </div>

            { displayCustomerInformation &&
                <Drawer title='Customer Information' open={displayCustomerInformation} onClose={() => setDisplayCustomerInformation(false)}>
                    <EditCustomerInformationForm dataSource={nocItem} setVisible={setDisplayCustomerInformation} refreshHandler={refreshHandler}/>
                </Drawer> 
            }

            { deleteCustomerModal &&
                <NocDeleteCustomerModal dataSource={nocItem} setDataSource={setDataSource} displayModal={deleteCustomerModal} setDisplayModal={setDeleteCustomerModal} refreshHandler={refreshHandler}/> 
            }
        </>
    );
};